import React from 'react'
import { Button, Modal } from 'react-bootstrap'

function InvestmentDeleteModal({ investment, onConfirm, onCancel }) {
  return (
    <Modal show animation={false}>
      <Modal.Header>
        <Modal.Title>Delete Investment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Delete <strong>{investment.symbol}</strong> from <strong>{investment.account}</strong>? This cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm}>Delete</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InvestmentDeleteModal
